<template>
  <div class="bb-new-user">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-new-user-wrapper" v-click-outside="closeModal">
      <div>
        <div class="bb-new-user-avatar-container">
          <img class="bb-new-user-avatar-container__img" :src="newUser.image ? newUser.image.path : defaultAvatar">
          <img class="bb-new-user-avatar-container__btn-upload" src="@/assets/images/icon-photo.png"/>
          <input class="bb-new-user-avatar-container__btn-upload bb-new-user-avatar-container__btn-upload_input"
                 name="upload-logo"
                 type="file"
                 accept="image/*"
                 @click.stop
                 @change="processFile($event)">
        </div>
      </div>
      <div class="bb-new-user-form">
        <div class="bb-new-user-form-item bb-form">
          <label for="firstName" class="bb-form__label">First name</label>
          <input class="bb-new-user-form-item__input bb-new-user-form-item__input_username bb-input bb-input_border"
                 v-autofocus
                 autocomplete="off"
                 @keyup.esc="closeModal()"
                 @keyup.enter="confirmForm()"
                 id="firstName"
                 type="text"
                 v-model="newUser.firstName" :class="{'bb-new-user-form-item__input_error':errors.firstName}">
          <span v-if="errors.firstName"
                class="bb-new-user-form-item__input_taken">{{errors.firstName}}</span>
        </div>
        <div class="bb-new-user-form-item bb-form">
          <label for="lastName" class="bb-form__label">Last name</label>
          <input class="bb-new-user-form-item__input bb-new-user-form-item__input_username bb-input bb-input_border"
                 autocomplete="off"
                 @keyup.esc="closeModal()"
                 @keyup.enter="confirmForm()"
                 id="lastName"
                 type="text"
                 v-model="newUser.lastName" :class="{'bb-new-user-form-item__input_error':errors.lastName}">
          <span v-if="errors.lastName"
                class="bb-new-user-form-item__input_taken">{{errors.lastName}}</span>
        </div>
        <div class="bb-new-user-form-item">
          <label for="role" class="bb-form__label">Role</label>
          <custom-select class="bb-new-user-form-item__input bb-new-user-form-item__input_select" id="role"
                         :list="roleList"
                         :default-val="role"
                         minHeight="230px"
                         @setValue="setRole"
          />
        </div>
        <div class="bb-new-user-form-item">
          <label for="phone" class="bb-form__label">Phone</label>
          <input class="bb-new-user-form-item__input bb-input bb-input_border"
                 autocomplete="new-phone"
                 @keyup.esc="closeModal()"
                 @keyup.enter="confirmForm()"
                 id="phone"
                 type="tel"
                 v-model="newUser.phone">
        </div>
        <div class="bb-new-user-form-item">
          <label for="position" class="bb-form__label">Position</label>
          <custom-select class="bb-new-user-form-item__input bb-new-user-form-item__input_select" id="position"
                         :list="positionsList"
                         :default-val="position"
                         @setValue="setPositions"/>
        </div>
        <div class="bb-new-user-form-item bb-form">
<!--          bb-new-user-form-item__input bb-new-user-form-item__input_email-->
          <label class="bb-form__label">Email</label>
          <div
            v-if="edit"
            class="bb-new-user-form-item__input bb-new-user-form-item__input_email"
          >
            {{newUser.email}}
          </div>
          <div
            v-else
            class="bb-new-user-form-item-email"
            :class="{'bb-new-user-form-item-email_error': errors.server}"
          >
            <input
              class="bb-new-user-form-item__input bb-new-user-form-item__input_username bb-input bb-input_border"
              type="text"
              autocomplete="off"
              v-model="emailInput"
              @input="generateEmail"
              @keyup.esc="closeModal()"
              @keyup.enter="confirmForm()"
              @keyup="onKeyUp"
            />
            <div
              class="bb-new-user-form-item-email__domain"
              :class="{'bb-new-user-form-item-email__domain_error': errors.server}"
            >
              {{emailDomain}}
            </div>
            <span
              v-if="errors.server"
              class="bb-new-user-form-item__input_taken"
            >
            {{errors.server}}
          </span>
          </div>
        </div>
        <div class="bb-new-user-form-item" v-if="!this.edit">
          <label for="password" class="bb-form__label">
            Password
          </label>
          <input class="bb-new-user-form-item__input bb-input bb-input_border"
                 autocomplete="off"
                 @keyup.esc="closeModal()"
                 @keyup.enter="confirmForm()"
                 id="password"
                 type="password"
                 :class="{'bb-new-user-form-item__input_error':errors.password}"
                 v-model="newUser.password">
          <span v-if="errors.password"
                class="bb-new-user-form-item__input_taken">{{errors.password}}</span>
        </div>
        <div class="bb-new-user-form-item" v-if="edit">
          <label for="newpassword" class="bb-form__label bb-form__label_password"
                 @click="passwordOpen = !passwordOpen">
            New password
          </label>
          <transition name='fade'>
            <div class="bb-new-user-form-item__newpass" v-if="passwordOpen">
              <input class="bb-new-user-form-item__input bb-new-user-form-item__input_newpass bb-input bb-input_border"
                     autocomplete="off"
                     @keyup.esc="closeModal()"
                     @keyup.enter="confirmForm()"
                     id="newpassword"
                     :class="{'bb-new-user-form-item__input_error' : errors.password}"
                     type="password" minlength="8" maxlength="100"
                     v-model="newUser.password">
              <span v-if="errors.password"
                    class="bb-new-user-form-item__input_taken">{{errors.password}}</span>
            </div>
          </transition>
        </div>
        <label class="bb-new-user-form-item bb-new-user-form-item_mass-mailing">
          <span class="bb-form__label">Access to mass mailing</span>
          <div class="bb-new-user-form-item__input bb-new-user-form-item__input_mass-mailing">
            <checkbox class-checkbox=" bb-new-user-form-checkboxes__checkbox"
                      :value="newUser.massMailingCheck"
                      @checkboxChange="massMailingChange"/>
          </div>
        </label>
        <div class="bb-new-user-form-item" v-for="(menuItem,index) in allMenu" :key="menuItem.id"
             v-if="menuItem.id!== 8">
          <label class="bb-form__label bb-form__label_checkbox"
                 v-if="index === 0">Access</label>
          <div class="bb-new-user-form-item__input bb-new-user-form-checkboxes bb-input bb-input_border"
               :class="{'bb-new-user-form-checkboxes_open': openCheckboxList
               && openCheckboxIndex === index && menuItem.submenu.length}"
          >
            <div class="bb-new-user-form-checkboxes__section" @click="openSubCheckboxes(index)">
              <checkbox :checkbox-text="menuItem.title" :name="menuItem.access"
                        class-checkbox=" bb-new-user-form-checkboxes__checkbox"
                        :section="menuItem.access"
                        :value="getValueCheckbox(menuItem, menuItem)"
                        @checkboxChange="checkboxChange"/>
              <i
                v-if="menuItem.submenu.length"
                class="icon-arrow-select bb-new-user-form-checkboxes__arrow"
              />
            </div>
            <transition-group name="fade-submenu" tag="div">
              <div
                v-if="!subMenuItem.hideAccessUser"
                v-show="openCheckboxList && openCheckboxIndex === index"
                v-for="subMenuItem in menuItem.submenu" :key="subMenuItem.id"
                class="bb-new-user-form-checkboxes__sub-sections"
              >
                <checkbox
                  :checkbox-text="subMenuItem.title"
                  :name="subMenuItem.access"
                  class-checkbox=" bb-new-user-form-checkboxes__checkbox"
                  :section="menuItem.access"
                  :value="getValueCheckbox(menuItem, subMenuItem)"
                  @checkboxChange="checkboxChange"
                />
              </div>
            </transition-group>
          </div>
        </div>
        <div>
          <div class="bb-new-user-form-btns">
            <button class="bb-new-user-form-btns__btn bb-button"
                    @click="editUser()"
                    v-if="user"
                    :disabled="disableSave">
              SAVE
            </button>
            <button class="bb-new-user-form-btns__btn bb-button" @click="createUser()" v-if="!user">ADD</button>
          </div>
        </div>
      </div>
      <span v-if="errors.google" class="bb-new-user-form-btns__error">
        {{errors.google}}
      </span>
    </div>
    <ModalWindow v-if="file" @close="file = false" @click.stop>
      <UploadImage :file="file" @uploadFile="setFileData" @click.stop/>
    </ModalWindow>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import checkbox from '@/components/Main/Inputs/checkbox'
import UsersListApi from '@/api/UsersList/api'
import PositionApi from '@/api/PositionList/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {menu} from '@/constants/menu'
import {ROLES_LIST} from '@/constants/roles'
import _ from 'lodash'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import UploadImage from '@/components/Main/UploadImage/UploadImage'
import defaultAvatar from '@/assets/images/user.png'
import UploadFileApi from '@/api/UploadFile/api'
import {CEO, FOUNDER} from '../../../constants/roles'

export default {
  name: 'NewUserForm',
  components: {
    CustomSelect,
    checkbox,
    LoaderFly,
    ModalWindow,
    UploadImage
  },
  props: {
    user: Object,
    index: Number,
    edit: Boolean
  },
  data () {
    return {
      cancelDelete: false,
      checkedEmail: true,
      errors: {
        password: false,
        firstName: false,
        lastName: false,
        google: false,
        server: false
      },
      loaderRun: false,
      deleteConfirmOpen: false,
      openCheckboxList: false,
      openCheckboxIndex: 0,
      role: false,
      position: false,
      access: false,
      passwordOpen: false,
      roleList: [],
      allMenu: _.filter(menu, item => !item.hideAccessUser),
      newUser: {
        email: '',
        access: {
          communications: {
            communications: true,
            hr: true,
            internalCommunication: true,
            inspectionsAndReport: true
          },
          commercialOffers: {
            commercialOffers: true
          },
          dissemination: {
            dissemination: true,
            promotionMarketing: true,
            publicationsPR: true,
            salesCRM: true
          },
          finance: {
            finance: true,
            income: true,
            expenses: true,
            assetsMaterialsRecords: true,
            assets: true,
            kpi: true
          },
          services: {
            services: true,
            interns: true,
            projectManagement: true,
            businessConsulting: true
          },
          qualifications: {
            qualifications: true,
            qualityControl: true,
            educationAcademy: true,
            certificationsAwards: true
          },
          businessDevelopment: {
            businessDevelopment: true,
            partnersAndReferals: true,
            businessClubsAssociacions: true,
            publicInformationService: true
          },
          executive: {
            executive: true,
            officeOfFounder: true,
            officeOfCorpAffairs: true,
            officeOfTheCEO: true
          },
          crm: {
            crm: true,
            clientTrackingList: true,
            listOfProjects: true,
            listOfRequests: true
          },
          hr: {
            hr: true,
            documentList: true,
            timeOff: true,
            assets: true,
            hrLetters: true,
            reports: true
          },
          statistics: {
            executionDepartment12: false
          }
        }
      },
      file: false,
      imgSrc: false,
      defaultAvatar: defaultAvatar,
      disableSave: false,
      pendingFile: false,
      emailInput: ''
    }
  },
  computed: {
    bbConfigApiKeys () {
      return this.$store.getters.bbConfigApiKeys
    },
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    },
    currentCompany () {
      return this.$store.getters.currentCompany
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    positionsList: {
      get: function () {
        return this.$store.getters.positionsList
      },
      set: function (data) {
        this.$store.dispatch('setPositionsList', data)
      }
    },
    emailDomain () {
      const { emailDomain = 'uae-consulting.com' } = this.currentCompany
      const fullEmailDomain = emailDomain.charAt(0) === '@' ? emailDomain : `@${emailDomain}`
      return fullEmailDomain
    },
    getDebounce () {
      return _.debounce(this.addEmail, 250)
    }
  },
  methods: {
    massMailingChange (data) {
      this.newUser.massMailingCheck = data
    },
    async uploadFile (isShowLoader = true) {
      if (isShowLoader) {
        this.loaderRun = true;
      }
      try {
        const res = await UploadFileApi.createFile(this.pendingFile)
        return res.data
      } catch (err) {
        console.error(err);
      } finally {
        if (isShowLoader) {
          this.loaderRun = false;
        }
      }
    },
    setFileData (fileData, file) {
      const userId = this.newUser.id
      const label = fileData.get('file').name
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', label)
      fileData.set('parentId', userId)
      fileData.set('onModel', 'User')
      this.file = false
      this.imgSrc = file
      _.set(this.newUser, 'image.path', file)
      this.pendingFile = fileData
    },
    processFile (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.file = files[0]
    },
    confirmForm () {
      if (this.user) {
        this.editUser()
      } else this.createUser()
    },
    openSubCheckboxes (index) {
      if (this.openCheckboxIndex === index) {
        this.openCheckboxList = false
        this.openCheckboxIndex = false
      } else {
        this.openCheckboxList = true
        this.openCheckboxIndex = index
      }
    },
    closeModal () {
      this.$emit('close')
    },
    getValueCheckbox (menuItem, subMenuItem) {
      const accessName = _.get(menuItem, 'access', {})
      const subAccessName = _.get(subMenuItem, 'access', '')
      return _.get(this.newUser, ['access', accessName, subAccessName], false)
    },
    checkboxChange (data, name, section) {
      _.set(this.newUser, ['access', section, name], data)
      _.forEach(this.newUser.access, (sectionElement, index) => {
        if (name === index) {
          const result = {}
          _.forEach(sectionElement, (subSection, subIndex) => {
            result[subIndex] = data
            _.set(this.newUser, ['access', index], result)
          })
        }
      })
      this.newUser = _.cloneDeep(this.newUser)
    },
    setRole (role) {
      const { role: userRole } = this.newUser
      if (role) {
        const { id } = role
        if (id === userRole) return true
        this.newUser.role = id
        const { position, access } = this.newUser
        const { commercialoffers = { commercialoffers: false } } = access
        const currentPosition = this.positionsList.find((item) => item.id === position)
        const department = _.get(currentPosition, 'department', -1)
        commercialoffers.commercialoffers = department === 1 || id === FOUNDER.id || id === CEO.id
        this.$set(this.newUser, 'access', {...access, commercialoffers})
      }
    },
    setPositions (position) {
      const { position: userPosition = {} } = this.newUser
      if (position) {
        const { id, department } = position
        const { id: userPositionId } = userPosition
        if (id === userPositionId) return true
        const { role, access } = this.newUser
        const { commercialoffers = { commercialoffers: false } } = access
        this.newUser.position = id
        commercialoffers.commercialoffers = department === 1 || role === FOUNDER.id || role === CEO.id
        this.$set(this.newUser, 'access', {...access, commercialoffers})
      }
    },
    inputsCheck (edit) {
      this.errors.google = false
      let haveError = false
      if (!this.newUser.password && !edit) {
        this.errors.password = 'mandatory field'
        haveError = true
      } else if (this.newUser.password && this.newUser.password.length < 8) {
        this.errors.password = 'password must be 8 characters'
        haveError = true
      } else if (this.newUser.password && this.newUser.password.length > 100) {
        this.errors.password = 'password must not exceed 100 characters'
        haveError = true
      } else if (this.newUser.password === '12345678') {
        this.errors.password = 'password is too simple'
        haveError = true
      } else {
        this.errors.password = false
      }
      if (!this.newUser.firstName) {
        this.errors.firstName = 'mandatory field'
        haveError = true
      } else {
        this.newUser.firstName = _.capitalize(this.newUser.firstName)
        this.errors.firstName = false
      }
      if (!this.newUser.lastName) {
        this.errors.lastName = 'mandatory field'
        haveError = true
      } else {
        this.newUser.lastName = _.capitalize(this.newUser.lastName)
        this.errors.lastName = false
      }
      if (this.errors.server) haveError = true
      if (!this.emailInput) {
        haveError = true
        this.errors.server = 'mandatory field'
      }

      return haveError
    },
    errorsCheck (errObj) {
      const errors = _.get(errObj, 'response.data.errors', '')
      const firstErr = Object.keys(errors)[0]
      if (errors[firstErr]) {
        this.errors[firstErr] = errors[firstErr]
      }
    },
    onKeyUp ({ key }) {
      if (key !== '@') return
      const emailSplit = this.emailInput.split('')
      const index = emailSplit.findIndex((el) => el === '@')
      emailSplit.splice(index, 1)
      this.emailInput = emailSplit.join('')
    },
    async generateEmail (event) {
      const { target } = event
      const { value = '' } = target
      this.emailInput = value
      const email = `${value}${this.emailDomain}`
      this.getDebounce(email)
    },
    async addEmail (email) {
      this.errors.server = false
      const checkEmail = await this.checkEmail(email)
      const checked = _.get(checkEmail, 'email', true)
      if (!checked) {
        this.$set(this.newUser, 'email', email)
      } else {
        this.errors.server = 'Email is used'
      }
    },
    async checkEmail (email) {
      try {
        const {data} = await UsersListApi.checkEmail(email)
        return data
      } catch (err) {
        this.errors.server = _.get(err, 'response.statusText', 'No response from server')
        console.error(err)
      }
    },
    async createUser () {
      if (this.inputsCheck()) {
        return
      }
      this.newUser.username = this.newUser.firstName + ' ' + this.newUser.lastName;
      this.newUser.company = this.activeCompany;

      this.newUser.email = this.newUser.email.split('').filter(symbol => symbol !== ' ').join('');
      this.newUser.login = this.newUser.email.replace('-', '');

      this.loaderRun = true;
      if (this.pendingFile) delete this.newUser.image;
      await this.initUser();
    },
    async initUser () {
      if (this.pendingFile) {
        const data = await this.uploadFile();
        this.newUser.image = data.id;
      }
      UsersListApi.createUser(this.newUser)
        .then((resp) => {
          this.newUser = resp.data;
          this.countEmail = 1;
          this.closeModal();
          this.users.unshift(resp.data);
        })
        .catch((err) => {
          this.errorsCheck(err);
        })
        .finally(() => {
          this.loaderRun = false;
        })
    },
    async editUser (noClose) {
      this.loaderRun = true;

      if (this.pendingFile) {
        const data = await this.uploadFile(false);
        this.newUser.image = data.id;
      }

      const idImage = _.get(this.newUser, 'image.id', false);
      if (idImage) _.set(this.newUser, 'image', idImage);
      const idPosition = _.get(this.newUser, 'position.id', false);
      if (idPosition) _.set(this.newUser, 'position', idPosition);

      if (this.inputsCheck('edit')) {
        this.loaderRun = false;
        return;
      }

      this.newUser.username = this.newUser.firstName + ' ' + this.newUser.lastName;
      delete this.newUser.login;
      delete this.newUser.email;

      UsersListApi.editUser(this.newUser)
        .then((resp) => {
          this.newUser = resp.data;
          this.users.splice(this.index, 1, resp.data);
          if (this.userInfo.id === resp.data.id) {
            this.userInfo = resp.data;
          }
          noClose ? this.disableSave = false : this.closeModal();
        })
        .catch((err) => {
          this.errorsCheck(err);
          console.error(err);
        })
        .finally(() => {
          this.loaderRun = false;
        })
    },
    getPositions () {
      PositionApi.getPositions()
        .then((resp) => {
          this.positionsList = _.sortBy(resp.data.positions, ['name'])
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.getPositions()
    const { role } = this.userInfo
    const isFounder = role === FOUNDER.id
    const roles = [...ROLES_LIST]
    if (!isFounder) {
      const founderIndex = roles.findIndex(({id}) => id === FOUNDER.id)
      if (founderIndex !== -1) {
        roles.splice(founderIndex, 1)
      }
    }
    const [firstRole] = roles
    this.role = firstRole.id
    this.roleList = [...roles]

    if (this.edit) {
      const editableId = _.get(this.users, this.index + '.id', '')
      const userId = _.get(this.userInfo, 'id', '')
      this.cancelDelete = editableId === userId
      this.access = this.users[this.index].access
      this.role = this.users[this.index].role
      this.position = this.users[this.index].position
      this.emailInput = this.users[this.index].email
    }
    Object.assign(this.newUser, this.user)
  }
}

</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";
@import "../../../sass/transition";

.bb-new-user {

  &-wrapper {
    @include global-font;
    position: relative;
    display: flex;
    background-color: $color-white;
    padding: 20px 0;
    border-radius: 8px;

    &__exit {
      position: absolute;
      top: 13px;
      right: 13px;
      color: $color-silver;
      cursor: pointer;
    }
  }

  &-avatar-container {
    position: relative;
    display: flex;
    justify-content: center;

    &__img {
      border-radius: 50%;
      width: 130px;
      height: 130px;
    }

    &__btn-upload {
      position: absolute;
      bottom: -13px;
      width: 33px;
      height: 33px;
      cursor: pointer;

      &_input {
        width: 33px;
        height: 33px;
        opacity: 0;
        font-size: 0;
        cursor: pointer;
      }
    }
  }

  &-form {
    display: flex;
    flex-direction: column;
    padding-bottom: 150px;
    align-items: stretch;
    margin-left: 29px;

    &-item {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      &_mass-mailing {
        cursor: pointer;
      }

      &__newpass {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      &__input {
        min-width: 366px;
        height: 30px;
        font-size: 12px;

        &_mass-mailing {
          padding: 8px 15px;
        }

        &_email {
          display: flex;
          align-items: center;
          padding: 15px 8px;
        }

        &:invalid,
        &_error {
          border-color: $color-red-orange;
        }

        &_taken {
          position: absolute;
          right: 12px;
          color: $color-red-orange;
          font-size: 11px;
          line-height: 13px;
        }

        &_username {
          text-transform: capitalize;
        }

        &_newpass {
          min-width: 366px;
        }

        &_select {
          border: none;
        }
      }
    }

    &-btns {
      position: fixed;
      bottom: 100px;
      z-index: 2;
      background-color: $color-white;
      max-width: 365px;
      width: 100%;
      margin-top: 40px;
      margin-left: 138px;
      display: flex;

      &__btn {
        width: 117px;
        box-sizing: border-box;
        border: 2px solid transparent;

        &_delete {
          position: relative;
          margin-left: 16px;
          color: $color-red-orange;
          background-color: $color-white;
          border-color: rgba($color-red-orange, 1);
        }
      }

      &__error {
        color: $color-red-orange;
        max-width: 315px;
        word-break: break-word;
        font-size: 11px;
        line-height: 13px;
        position: absolute;
        left: 0;
        bottom: 50px
      }
    }

    &-checkboxes {
      position: relative;
      margin-left: auto;
      max-height: 32px;
      transition: max-height .4s ease-in-out;
      user-select: none;

      &_open {
        max-height: 700px;
        height: 100%;
        transition: max-height .4s ease-in-out;
      }

      &__section {
        position: relative;
        display: flex;
        align-items: center;
        z-index: 1;
        cursor: pointer;
      }

      &__sub-sections {
        margin: 8px auto 0 23px;

        &:first-child {
          margin-top: 20px;
        }
      }

      &__arrow {
        position: absolute;
        top: 0;
        right: 12px;
        font-size: 5px;
        color: $color-accent;
        transition: all .2s linear;
        cursor: pointer;
      }
    }
  }

  &-delete {
    position: absolute;
    bottom: 47px;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: $color-white;
    box-shadow: 0 0 15px rgba($color-black, 0.05);
    border-radius: 5px;
    z-index: 1;
    padding: 14px;
    min-width: 117px;
    color: $color-black;

    &:after {
      position: absolute;
      bottom: -10px;
      right: 54px;
      content: '';
      border: 5px solid transparent;
      border-top: 5px solid $color-white;
      box-shadow: 0 0 15px rgba($color-black, 0.05);
    }

    &__text {
      font-size: 14px;
      line-height: 17px;
      white-space: nowrap;
    }

    &__btn-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    &__btn {
      margin-top: 13px;
      width: 39px;
      height: 26px;
      color: $color-white;
      background: $color-accent;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      line-height: 14px;
    }
  }
}

  .bb-new-user-form-item-email {
    display: grid;
    grid-template-columns: 1fr max-content;
    align-items: center;
    max-width: 366px;
    min-width: 366px;
    border: 1px solid $color-wild-sand;
    box-sizing: border-box;
    border-radius: 5px;
    position: relative;

    &_error {
      border-color: $color-red-orange;
    }

    &__domain {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 20px 0 10px;
      font-size: 12px;
      border-left: 1px solid $color-wild-sand;

      &_error {
        border-color: $color-red-orange;
      }
    }

    .bb-new-user-form-item__input {
      min-width: 100px;
      padding: 7px 10px;
      overflow: hidden;
      border: none;
    }

    .bb-new-user-form-item__input_taken {
      bottom: -13px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Forms/NewUserForm.vue